import CapitalGainAPI from './CapitalGainAPI';
import CapitalGainRecord from './CapitalGainRecord';
import LiquidityCapitalGainError from './LiquidityCapitalGainError';
import RealEstateCapitalGainError from './RealEstateCapitalGainError';
import StandardCapitalGainError from './StandardCapitalGainError';
export { CapitalGainRecord, LiquidityCapitalGainError, RealEstateCapitalGainError, StandardCapitalGainError };
export default CapitalGainAPI;
